var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("b-container", { staticClass: "p-0", attrs: { fluid: "" } }, [
    _vm.show
      ? _c(
          "div",
          { class: { "not-allowed-backdrop": true, mobile: _vm.isMobile } },
          [
            _c(
              "div",
              { class: { "not-allowed-modal": true, mobile: _vm.isMobile } },
              [
                _c("div", { staticClass: "not-allowed-message" }, [
                  _vm._v(_vm._s(_vm.msg))
                ]),
                _vm.isMobile
                  ? _c(
                      "div",
                      { staticClass: "not-allowed-close" },
                      [
                        _c("cancel", {
                          attrs: { label: "閉じる" },
                          on: { cancel: _vm.doAppClose }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ]
            )
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }